<div class="modal-header modal-h" *ngIf="document">
    <h5 class="modal-title" *ngIf="type === 'flexible'">{{document.benefitName}}</h5>
    <h5 class="modal-title" *ngIf="type === 'fixed'">{{document.documentName}}</h5>
    <button type="button" class="btn-close" (click)="closeBtnClick(false)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-b">
    <div class="text" id="show-text-area">
        <div class="btn-group"  *ngIf="isMobile()">
            <button class="btn btn-icon" (click)="changeZoom(0.25)"><span [data-feather]="'zoom-in'"></span></button>
            <button class="btn btn-icon" (click)="changeZoom(-0.25)"><span [data-feather]="'zoom-out'"></span></button>
        </div>
        <iframe title="{{ document.displayName ?? document.benefitName }}" *ngIf="!isMobile() && !isMobileBrowser" [src]="document.documentUrl | safe:'resourceUrl'" class="document-pdf-viewer" width="100%" height="100%"></iframe>
        <pdf-viewer *ngIf="isMobile() || isMobileBrowser"
                [src]="document.documentUrl"
                [rotation]="0"
                [original-size]="false"
                [show-all]="true"
                [fit-to-page]="true"
                [zoom]="zoom"
                [zoom-scale]="'page-fit'"
                [stick-to-page]="true"
                [render-text]="true"
                [external-link-target]="'blank'"
                [autoresize]="true"
                [show-borders]="false"
                style="width: 100%; height: 100%;"
        ></pdf-viewer>
    </div>
    <div class="d-flex buttons">
        <button *ngIf="type !== 'fixed'" class="btn-primary" (click)="closeBtnClick(true)"><span class="ficon feather icon-check-square"></span>{{ 'BENEFIT_SUMMARY.DOCUMENTS.DOC_READ' | translate }}
        </button>
    </div>
</div>
